import axios from 'axios'

export default async (config) => {
  const accessToken = localStorage.getItem('accessToken')

  if (!accessToken) {
    throw new Error('Access token missing')
  }

  // Set Authorization header
  config.headers = {
    ...(config.headers || {}),
    Authorization: `Bearer ${accessToken}`,
  }

  try {
    // Make the actual API call
    const response = await axios(config)
    return response.data
  } catch (error) {
    // Check for token expiration
    if (
      error.response &&
      error.response.status === 403 &&
      error.response.data?.code === 'invalid-or-expired-token'
    ) {
      const refreshToken = localStorage.getItem('refreshToken')
      if (!refreshToken) {
        console.error('Refresh token missing')
        throw error
      }

      try {
        const refreshResponse = await axios.post(
          `${import.meta.env.VITE_HOST}/oauth/refresh-token/wikimedia/`,
          { refresh_token: refreshToken },
        )

        const newAccessToken = refreshResponse.data.access_token
        const newRefreshToken = refreshResponse.data.refresh_token
        localStorage.setItem('accessToken', newAccessToken)
        localStorage.setItem('refreshToken', newRefreshToken)

        // Retry original request with new token
        config.headers.Authorization = `Bearer ${newAccessToken}`
        return (await axios(config)).data
      } catch (refreshError) {
        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')
        console.error('Token refresh failed. Please login again', refreshError)
        throw refreshError
      }
    }

    // Unknown error or not token related
    throw error
  }
}
